import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ns-template-window',
  templateUrl: './template-window.component.html',
  styleUrls: ['./template-window.component.scss']
})
export class TemplateWindowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
